import axios from 'axios';
import setAuthToken from '../utils/setAuthToken';
import { setAlert } from './alert';
import {
    CREATE_PAYMENT_LINK_SUCCESS,
    CREATE_PAYMENT_LINK_ERROR,
    GET_ALL_PAYMENT_LINKS_SUCCESS,
    GET_ALL_PAYMENT_LINKS_ERROR,
    GET_PAYMENT_LINK_BY_ID_SUCCESS,
    GET_PAYMENT_LINK_BY_ID_ERROR,
    VERIFY_PAYMENT_LINK_STATUS_SUCCESS,
    VERIFY_PAYMENT_LINK_STATUS_ERROR,
    PAYMENT_LINK_LOADING,
    CLEAR_PAYMENT_LINK
} from './types';

const API_URL = process.env.REACT_APP_SERVER_API_URL;

// Create Payment Link
export const createPaymentLink = (paymentLinkData) => async dispatch => {
    if (localStorage.token) {
        setAuthToken(localStorage.token);
    }
    try {
        dispatch({ type: PAYMENT_LINK_LOADING });
        
        const res = await axios.post(
            `${API_URL}/orders/razorpay-payment-link`,
            paymentLinkData
        );
        
        if (res.data.error === false) {
            dispatch({
                type: CREATE_PAYMENT_LINK_SUCCESS,
                payload: res.data.data
            });
            dispatch(setAlert(res.data.message || 'Payment link created successfully', 'success'));
            return res.data.data;
        } else {
            const errorMessage = res.data.message || 'Failed to create payment link';
            dispatch({
                type: CREATE_PAYMENT_LINK_ERROR,
                payload: errorMessage
            });
            dispatch(setAlert(errorMessage, 'danger'));
            throw new Error(errorMessage);
        }
    } catch (err) {
        const errorMessage = err.response?.data?.message || err.message || 'Failed to create payment link';
        dispatch({
            type: CREATE_PAYMENT_LINK_ERROR,
            payload: errorMessage
        });
        dispatch(setAlert(errorMessage, 'danger'));
        throw err;
    }
};

// Get All Payment Links
export const getAllPaymentLinks = (params = {}) => async dispatch => {
    if (localStorage.token) {
        setAuthToken(localStorage.token);
    }
    try {
        dispatch({ type: PAYMENT_LINK_LOADING });
        
        const queryParams = new URLSearchParams();
        if (params.page) queryParams.append('page', params.page);
        if (params.count) queryParams.append('count', params.count);
        if (params.latest !== undefined) queryParams.append('latest', params.latest);
        
        const url = `${API_URL}/payment/payment-links-list${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
        const res = await axios.get(url);
        
        if (res.data.success) {
            dispatch({
                type: GET_ALL_PAYMENT_LINKS_SUCCESS,
                payload: res.data
            });
            return res.data;
        } else {
            const errorMessage = res.data.error || 'Failed to fetch payment links';
            dispatch({
                type: GET_ALL_PAYMENT_LINKS_ERROR,
                payload: errorMessage
            });
            dispatch(setAlert(errorMessage, 'danger'));
            throw new Error(errorMessage);
        }
    } catch (err) {
        const errorMessage = err.response?.data?.error || err.message || 'Failed to fetch payment links';
        dispatch({
            type: GET_ALL_PAYMENT_LINKS_ERROR,
            payload: errorMessage
        });
        dispatch(setAlert(errorMessage, 'danger'));
        throw err;
    }
};

// Get Payment Link by ID
export const getPaymentLinkById = (paymentLinkId) => async dispatch => {
    if (localStorage.token) {
        setAuthToken(localStorage.token);
    }
    try {
        dispatch({ type: PAYMENT_LINK_LOADING });

        const res = await axios.get(
            `${API_URL}/payment/payment-links/${paymentLinkId}`
        );

        if (res.data.success) {
            dispatch({
                type: GET_PAYMENT_LINK_BY_ID_SUCCESS,
                payload: res.data.data
            });
            return res.data.data;
        } else {
            const errorMessage = res.data.error || 'Failed to fetch payment link';
            dispatch({
                type: GET_PAYMENT_LINK_BY_ID_ERROR,
                payload: errorMessage
            });
            dispatch(setAlert(errorMessage, 'danger'));
            throw new Error(errorMessage);
        }
    } catch (err) {
        const errorMessage = err.response?.data?.error || err.message || 'Failed to fetch payment link';
        dispatch({
            type: GET_PAYMENT_LINK_BY_ID_ERROR,
            payload: errorMessage
        });
        dispatch(setAlert(errorMessage, 'danger'));
        throw err;
    }
};

// Verify Payment Link Status
export const verifyPaymentLinkStatus = (paymentLinkId) => async dispatch => {
    if (localStorage.token) {
        setAuthToken(localStorage.token);
    }
    try {
        dispatch({ type: PAYMENT_LINK_LOADING });

        const res = await axios.post(
            `${API_URL}/payment/payment-links/${paymentLinkId}`,
            {}
        );

        if (res.data.success) {
            dispatch({
                type: VERIFY_PAYMENT_LINK_STATUS_SUCCESS,
                payload: res.data.data
            });
            dispatch(setAlert(res.data.message || 'Payment link status verified and updated', 'success'));
            return res.data.data;
        } else {
            const errorMessage = res.data.error || 'Failed to verify payment link status';
            dispatch({
                type: VERIFY_PAYMENT_LINK_STATUS_ERROR,
                payload: errorMessage
            });
            dispatch(setAlert(errorMessage, 'danger'));
            throw new Error(errorMessage);
        }
    } catch (err) {
        const errorMessage = err.response?.data?.error || err.message || 'Failed to verify payment link status';
        dispatch({
            type: VERIFY_PAYMENT_LINK_STATUS_ERROR,
            payload: errorMessage
        });
        dispatch(setAlert(errorMessage, 'danger'));
        throw err;
    }
};

// Clear Payment Link
export const clearPaymentLink = () => dispatch => {
    dispatch({ type: CLEAR_PAYMENT_LINK });
};

